/**
 * @file 文档页页右侧锚点菜单
 * @author wanzhongyun
 */

import React from 'react';
import {Menu} from 'antd';

import LinkA from '../../../../components/a/LinkA';
import {IDocumentMenuItem} from '../../type';


const renderSubMenu = (menuList: IDocumentMenuItem[]) => (
    menuList.map(menuItem => {
        if (menuItem.children.length > 0) {
            return (
                <Menu.SubMenu
                    key={menuItem.key}
                    title={
                        <LinkA to={menuItem.link || ''}>
                            {menuItem.title}
                        </LinkA>
                    }
                >
                    {renderSubMenu(menuItem.children)}
                </Menu.SubMenu>
            );
        }
        return (
            <Menu.Item key={menuItem.key}>
                <LinkA to={menuItem.link || ''}>
                    {menuItem.title}
                </LinkA>
            </Menu.Item>
        );
    })
);


export interface IDocRightMenuProps {
    anchorOpenKeys: string[];
    anchorSelectedKeys: string[];
    anchorMenuList: IDocumentMenuItem[];
}

const DocRightMenu: React.FC<IDocRightMenuProps> = props => {
    const {
        anchorOpenKeys,
        anchorSelectedKeys,
        anchorMenuList
    } = props;

    return (
        <Menu
            className="paddle-doc-page-right-menu"
            mode="inline"
            inlineIndent={14}
            openKeys={anchorOpenKeys}
            selectedKeys={anchorSelectedKeys}
            expandIcon={<span />}
        >
            {renderSubMenu(anchorMenuList)}
        </Menu>
    );
};

export default DocRightMenu;
